import claimDataReducer from "./claimData"
import uiDataReducer from "./uiData"
import dropdownDataReducer from "./dropdownData"

import { combineReducers } from "redux"

const allReducers = combineReducers({
    claimData: claimDataReducer,
    uiData: uiDataReducer,
    dropdownData: dropdownDataReducer
})

export default allReducers
